import { IApplicationState } from '../../types/redux';
import { IDeveloperV2 } from '../../types/developerV2/developer';

export const getReviewsStats = (state: IApplicationState) => (state.developerV2 as IDeveloperV2).reviewsStats;
